import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./styles.css";
import { Navigation } from "swiper";
import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";

const defaultBreakpoints = {
  374: {
    slidesPerView: 2.5,
    spaceBetween: 0,
  },
  680: {
    slidesPerView: 4,
    spaceBetween: 0,
  },
  1200: {
    slidesPerView: 6,
    spaceBetween: 0,
  },
  1300: {
    slidesPerView: 7,
    spaceBetween: 0,
  },
  1800: {
    slidesPerView: 7,
    spaceBetween: 0,
  },
};

const Carousel = ({ items = [], breakpoints }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [navigationReady, setNavigationReady] = useState(false);

  useEffect(() => {
    setNavigationReady(true);
  }, []);

  return (
    <div className="relative w-full max-w-2xl mx-auto">
      {/* Botões com refs */}
      <Button
        ref={prevRef}
        type="button"
        icon="pi pi-arrow-left"
        className="custom-button-prev absolute bg-white "
        rounded
        style={{
          left: -10,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
          opacity: 1,
          color: "#344563",
          border: "1px solid #DFE1E6",
          boxShadow:
            "0 2px 4px -2px rgba(0,0,0,0.08), 0 4px 5px 0 rgba(0,0,0,0.06), 0 1px 10px 0 rgba(0,0,0,0.04)",
        }}
      />
      <Button
        ref={nextRef}
        type="button"
        icon="pi pi-arrow-right"
        className="custom-button-next absolute bg-white "
        rounded
        style={{
          right: -10,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2,
          opacity: 1,
          color: "#344563",
          border: "1px solid #DFE1E6",
          boxShadow:
            "0 2px 4px -2px rgba(0,0,0,0.08), 0 4px 5px 0 rgba(0,0,0,0.06), 0 1px 10px 0 rgba(0,0,0,0.04)",
        }}
      />
      {navigationReady && (
        <Swiper
          className="custom-swiper pt-5"
          slidesPerView={breakpoints ? undefined : "auto"}
          spaceBetween={0}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          modules={[Navigation]}
          breakpoints={breakpoints}
          loop={false}
          watchOverflow={true}
          slidesOffsetAfter={16}
        >
          {items.map((item, index) => (
            <SwiperSlide
              key={index}
              className="flex justify-content-center align-items-center custom-slide"
            >
              {item}
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};

export default Carousel;
